/** @import FileItem from '@/classes/files/FileItem' */

/**
 * Conjunto de callbacks agrupados para conocer el estado de un fichero
 */
export default class StatusCallback {
  /** @type {function(FileItem): boolean} */ loading = file => false
  /** @type {function(FileItem): boolean} */ success = file => true
  /** @type {function(FileItem): boolean} */ warning = file => false
  /** @type {function(FileItem): boolean} */ error = file => false
}
